import Api from '../api';
import qs from 'qs';

const LeaderboardEntryAPI = {
  async getAllSpeedrunEntries(params) {
    return Api.get(`/speedrun-entries/all?${qs.stringify(params)}`);
  },
  async getAllSpeedrunEntriesDetailed(params) {
    return Api.get(`/speedrun-entries/all-detailed?${qs.stringify(params)}`);
  },
  async getAllSpeedrunEntriesAgent(params) {
    return Api.get(`/speedrun-entries/agent-all?${qs.stringify(params)}`);
  },
  async getRandomSpeedrunEntry() {
    return Api.get('/speedrun-entries/');
  },
  async updateSpeedrunEntry(data) {
    return Api.post('/speedrun-entries/update', { data });
  },
  async createSpeedrunEntry(data) {
    return Api.post('/speedrun-entries/create', { data });
  },
  async deleteSpeedrunEntry(data) {
    return Api.post('/speedrun-entries/delete', { data });
  }
};

export default LeaderboardEntryAPI;
